import { Moment } from "@/typescript/lib/common/moment";
import { ReportCategories } from "@/typescript/pages/reports/types";
const format: string = "YYYY/MM/DD";

export const getReportCategories = (
  fromDate: string,
  toDate: string
): ReportCategories => {
  return {
    month: {
      disableToDate: true,
      msg: "1日深夜の0:00～月末23:50まで",
      minView: "month",
      fromDate: new Moment(format, fromDate, format).getStartOf("month"),
      toDate: new Moment(format, toDate, format).getEndOf("month")
    },
    week: {
      disableToDate: true,
      msg: "日曜深夜の0:00～土曜の23:50まで",
      minView: "day",
      fromDate: new Moment(format, fromDate, format).getStartOf("week"),
      toDate: new Moment(format, toDate, format).getEndOf("week")
    },
    day: {
      disableToDate: true,
      msg: "深夜の0:00～23:50まで",
      minView: "day",
      fromDate: new Moment(format, fromDate, format).getFormatDate(),
      toDate: new Moment(format, toDate, format).getFormatDate()
    },
    free: {
      disableToDate: false,
      msg: "初日深夜の0:00～末日23:50、最大3ヶ月",
      minView: "day",
      fromDate: new Moment(format, fromDate, format).getFormatDate(),
      toDate: new Moment(format, toDate, format).getFormatDate()
    }
  };
};
